'use strict';

window.TES = window.TES || {};

window.TES.savedSearch = (function() {


	var attachClickHandlers = function() {

		// remove Search
		$('BUTTON.remove').click(function() {
			var savedSearchId = $(this).data('searchid');
			var DATA = {"listId" : savedSearchId};

			$.ajax({
                type: 'DELETE',
                dataType: 'JSON',
                contentType: 'application/json; charset=utf-8',
				url: '/api/search/saved/remove',
				data: JSON.stringify(DATA),
                success: function(data, status, xhr) {
					if (data.success) {
						console.log('ajax success, yo');
						$('#savedSearch-'+savedSearchId).fadeOut(2000, function() { 
							$(this).remove(); 
						});
					}
				},
				error: function(xhr, status, err) {
					//console.log('Error removing search from list.');
					// TODO: flash error message to user
				}
			});
		});

		// add Search
		$('BUTTON.add').click(function() {

			$.ajax({
				type: 'POST',
				dataType: 'JSON',
				contentType: 'application/json; charset=utf-8',
				url: '/api/search/saved/add',
				data: JSON.stringify({}),
				success: function(data, status, xhr) {

				}, 
				error: function(xhr, status, err) {
					// TODO: flash error message to user
				}
			});
		});

	};

    return {

        init: function() {

			attachClickHandlers();
			/*
            user = window.TES.user;

            if (user.isAuthenticated()) {
                initAuthenticatedUserState();
            }
			*/
        }
    };
}());

$(function () {
    window.TES.savedSearch.init();
});
